export const getCanterburyData = () => ({
  name: "Canterbury",
  country: "Nouvelle-Zélande",
  description: "Canterbury est une région viticole située sur la côte est de l'île du Sud, réputée pour ses vins blancs frais et ses vins rouges élégants. Cette région bénéficie d'un climat maritime avec des influences alpines, créant des conditions idéales pour la viticulture.",
  type: "region",
  area: "1,500 ha",
  production: "0.12 million hectolitres",
  climate: "Climat maritime avec influences alpines, étés frais et hivers froids",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat maritime avec influences alpines, étés frais et hivers froids",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Viticulture durable, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs frais et minéraux, avec une belle acidité",
    red: "Pinot Noir élégant avec tanins fins et notes de fruits rouges",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Canterbury a commencé dans les années 1980 avec les premiers vignobles commerciaux. La région a développé une réputation pour ses vins blancs de qualité, notamment le Chardonnay et le Sauvignon Blanc. Aujourd'hui, Canterbury est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Fruits de mer, poissons blancs, fromages locaux, plats d'hiver, cuisine locale",
  subregions: {
    "Waipara Valley": {
      name: "Waipara Valley",
      description: "Vallée principale de Canterbury, spécialisée dans les vins blancs",
      area: "800 ha",
      characteristics: "Sols calcaires, climat maritime, vins frais",
      grapeVarieties: ["chardonnay", "sauvignon-blanc", "pinot-noir", "riesling"]
    },
    "North Canterbury": {
      name: "North Canterbury",
      description: "Zone viticole produisant des vins rouges et blancs de qualité",
      area: "400 ha",
      characteristics: "Sols argileux, climat tempéré, vins équilibrés",
      grapeVarieties: ["pinot-noir", "chardonnay", "sauvignon-blanc", "pinot-gris"]
    },
    "Central Canterbury": {
      name: "Central Canterbury",
      description: "Zone viticole traditionnelle avec des vignobles établis",
      area: "300 ha",
      characteristics: "Sols alluviaux, microclimats, vins aromatiques",
      grapeVarieties: ["sauvignon-blanc", "chardonnay", "pinot-noir", "gewurztraminer"]
    }
  },
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "35%",
      description: "Cépage blanc principal, produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "30%",
      description: "Cépage blanc produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "25%",
      description: "Cépage rouge principal, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Riesling",
      percentage: "5%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Pinot Gris, Gewürztraminer et cépages expérimentaux",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Waipara Valley", x: 172.5, y: -43.5, color: "#4B164C", size: 4 },
    { region: "North Canterbury", x: 172.7, y: -43.3, color: "#6d2c7a", size: 3 },
    { region: "Central Canterbury", x: 172.3, y: -43.7, color: "#8a4a8a", size: 2 }
  ]
}); 